var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"c-cbr-Hero c-cbr-Hero-outer",style:({backgroundImage: ("url(" + _vm.image + ")")})},[_vm._t("default",[_c('span',{staticClass:"c-cbr-Hero-param-wrapper",style:({
        backgroundColor: 'rgba(255, 255, 255, 0.2)'
      })},[_c('h1',{staticClass:"c-cbr-Hero-param",style:({color: _vm.heroTextColor})},[_vm._v("\n        "+_vm._s(_vm.$t('hero.headline_whitelabel',
              {
                customer: _vm.brandName,
                // prevent escaping of the company name
                interpolation: {
                  escapeValue: false
                }
              }
        ))+"\n      ")]),_vm._v(" "),_c('h2',{staticClass:"c-cbr-Hero-param",style:({color: _vm.heroTextColor})},[_vm._v(_vm._s(_vm.$t('hero.subheadline_whitelabel')))])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4952d521","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/CbrHero.vue
// module id = 215
// module chunks = 0